import React from "react";

/**
 * CircularProgress Component
 *
 * @param {object} props
 * @param {number} props.value - A number from 0 to 100 representing progress.
 * @param {number} [props.size=120] - Diameter of the circle in pixels.
 * @param {string} [props.strokeColor="#10b981"] - Stroke color for the progress (default: green).
 * @param {string} [props.bgStrokeColor="#e5e7eb"] - Background circle color (default: light gray).
 * @param {number} [props.strokeWidth=10] - Stroke width of the circle.
 */
const CircularProgress = ({
  value = 0,
  size = 120,
  strokeColor = "#034d28",
  bgStrokeColor = "#e5e7eb",
  strokeWidth = 10,
}) => {
  const normalizedValue = Math.min(Math.max(value, 0), 100); // Clamp between 0 and 100
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (normalizedValue / 100) * circumference;

  return (
    <div style={{ width: size, height: size, position: "relative" }}>
      <svg width={size} height={size}>
        <circle
          stroke={bgStrokeColor}
          fill="transparent"
          strokeWidth={strokeWidth}
          r={radius}
          cx={size / 2}
          cy={size / 2}
        />
        <circle
          stroke={strokeColor}
          fill="transparent"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          r={radius}
          cx={size / 2}
          cy={size / 2}
          style={{ transition: "stroke-dashoffset 0.5s ease" }}
        />
      </svg>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: size * 0.2,
          fontWeight: "bold",
          color: "#374151",
          fontFamily: "sans-serif",
        }}
      >
        {normalizedValue}%
      </div>
    </div>
  );
};

export default CircularProgress;
